import { LandingPageService } from './../../../../../core/services/landing-page.service';
import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { ValidationService } from 'src/app/core/services/validation.service';
import { ToastrService } from 'ngx-toastr';
import { API as AWS_API, Auth } from 'aws-amplify';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AppService } from 'src/app/core/services/app.service';
import { CONST_AWS_API, API } from 'src/app/core/constants';
import { CommanSubscribeService } from 'src/app/core/services/comman-subscribe.service';
import { environment } from 'src/environments/environment';
import { StorageService } from 'src/app/core/services/storage.service';
import { Subscription } from 'rxjs';
const EMAIL_REGEX = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;

@Component({
  selector: 'app-consumer-forgot-password',
  templateUrl: './consumer-forgot-password.component.html',
  styleUrls: ['./consumer-forgot-password.component.scss']
})
export class ConsumerForgotPasswordComponent implements OnInit {

  forgotPwdForm: FormGroup;
  isShowResetPassword: boolean = false;
  passwordIsValid = false;
  skipRedirection: any;
  skipIcRedirection:any;
  channelUrl: any;
  organization_id: any;
  performerInfoSubscription!: Subscription;
  constructor(private _formBuilder: FormBuilder, private landingPageService: LandingPageService,
    private appService: AppService, private commanSubscribeService: CommanSubscribeService,
    private matDialogRef: MatDialogRef<ConsumerForgotPasswordComponent>, private router: Router,
    private toastr: ToastrService, private ngxLoader: NgxUiLoaderService, private storageService: StorageService) { }

    settingsData:any={}
  ngOnInit() {
    this.settingsData = this.commanSubscribeService.icWebpageSettingsData;
    this.channelUrl = this.storageService.getItem('channelName')
    if(!this.router.url.includes(this.channelUrl)){
      this.settingsData={}
    }
    this.organization_id = this.commanSubscribeService.perfomerInfoData?.data?.Data[0]?.organization_id;
    this.performerInfoSubscription = this.commanSubscribeService.getPerfomerInfo().subscribe(response => {
      this.organization_id = response?.data?.Data[0]?.organization_id;
    });

    this.buildForm();
  }

  buildForm() {
    this.forgotPwdForm = this._formBuilder.group({
      email: ['', [Validators.required, ValidationService.emailValidator, Validators.pattern(EMAIL_REGEX)]],
      password: [''],
      confirmPassword: [''],
      otpCode: [''],
    });
  }

  OpenSign() {
    this.matDialogRef.close('');
    this.landingPageService.openConsumerSignIn();
  }
  closeModal() {
    this.matDialogRef.close();
    this.storageService.deleteItem('skipRedirection');
    this.storageService.deleteItem('skipIcRedirection');
  }
  requestPassword(from?: string) {
    if (this.forgotPwdForm.valid) {
      this.ngxLoader.start();
      Auth.forgotPassword(this.forgotPwdForm.value.email)
        .then(data => {
          this.ngxLoader.stop();
          this.isShowResetPassword = true;
          if(from !== "reset"){
            this.toastr.success("Otp send successfully");
          }
          let required = ["otpCode", "password", "confirmPassword"];
          required.forEach(e => {
            if (e == "confirmPassword") {
              this.forgotPwdForm.get(e).setValidators([Validators.required, ValidationService.confirmPasswordValidator]);
            } else if (e == "password") {
              this.forgotPwdForm.get(e).setValidators([Validators.required, ValidationService.isStrongPassword(this.passwordIsValid)]);
            } else {
              this.forgotPwdForm.get(e).setValidators([Validators.required]);
            }
            this.forgotPwdForm.get(e).updateValueAndValidity();
          });
        }).catch(err => {
          this.ngxLoader.stop();
          console.log(err);
          if (err && err.message) {
            this.toastr.error(err.message);
          }
        });
    }
  }

  resetPassword() {
    if (this.forgotPwdForm.valid) {
      this.ngxLoader.start();
      Auth.forgotPasswordSubmit(
        this.forgotPwdForm.value.email,
        this.forgotPwdForm.value.otpCode,
        this.forgotPwdForm.value.password)
        .then(data => {
          this.toastr.success("Reset password successfully");
          this.ngxLoader.stop();
          this.matDialogRef.close('');
          this.router.navigateByUrl('');
        }).catch(err => {
          this.ngxLoader.stop();
          console.log(err)
          if (err && err.message) {
            if(err.message == "You cannot reuse any of your last 12 passwords. Please choose a new password."){
            this.requestPassword('reset');
            this.toastr.error(err.message + " Sent new OTP to your mail");
          }else{
            this.toastr.error(err.message);
          }
          }
        });
    }
  }

  passwordValid(event) {
    this.passwordIsValid = event;
    setTimeout(() => {
      this.forgotPwdForm.get('password').setValidators([Validators.required, ValidationService.isStrongPassword(this.passwordIsValid)]);
      this.forgotPwdForm.get('password').updateValueAndValidity();
    }, 100);
  }

  // OL_requestPassword(){

  //   let reqData = {
  //     email : this.forgotPwdForm.value.email
  //   }
  //   this.ngxLoader.start();
  //   this.appService.OL_PostRequest(CONST_ONE_API.RESET_PASSWORD, reqData).subscribe(result => {
  //     this.ngxLoader.stop();
  //     if(result.status.code == 200){
  //       this.toastr.success(result.status.message);
  //         this.matDialogRef.close('');
  //     }
  //   }, error => {
  //     this.ngxLoader.stop();

  //   });
  // }

  OL_requestPassword(from?: string) {
    if (this.forgotPwdForm.valid) {
      let data = this.forgotPwdForm.getRawValue();
      data.email = data.email.toLowerCase();
      let myInit = {
        headers: {},
        response: true,
        body: {
          email: data.email,
          type: "forgot_password"
        }
      }
      this.ngxLoader.start();
      AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.SEND_OTP, myInit).then(response => {
        this.ngxLoader.stop();
        if (response.status == 200) {
          if (response.data && response.data.status == 1 && response.data.message) {
            if (response.data.message == "Email not found") {
              this.toastr.info(response.data.message);
            } else {
              this.toastr.success(response.data.message);
            }
          } else {
            this.isShowResetPassword = true;
            if(from !== "reset"){
              this.toastr.success("Otp send successfully");
            }
            let required = ["otpCode", "password", "confirmPassword"];
            required.forEach(e => {
              if (e == "confirmPassword") {
                this.forgotPwdForm.get(e).setValidators([Validators.required, ValidationService.confirmPasswordValidator]);
              } else if (e == "password") {
                this.forgotPwdForm.get(e).setValidators([Validators.required, ValidationService.isStrongPassword(this.passwordIsValid)]);
              } else {
                this.forgotPwdForm.get(e).setValidators([Validators.required]);
              }
              this.forgotPwdForm.get(e).updateValueAndValidity();
            });
          }
        }
      }).catch(error => {
        this.ngxLoader.stop();
      });
    }
  }

  OL_resetPassword() {
    if (this.forgotPwdForm.valid) {
      let data = this.forgotPwdForm.getRawValue();
      data.email = data.email.toLowerCase();
      this.ngxLoader.start();
      let params = {
        "email": data.email,
        "otp": Number(this.forgotPwdForm.value.otpCode),
        "password": this.forgotPwdForm.value.password,
        "organization_id": this.organization_id || 0
      }
      this.appService.postRequest(API.RESET_PASSWORD, params).subscribe(result => {
        this.ngxLoader.stop();
        console.log(result);
        if (result["status"] == 0) {
          this.toastr.success("Reset password successfully");
          this.matDialogRef.close('');
          this.skipRedirection = this.storageService.getItem('skipRedirection');
          this.skipIcRedirection = this.storageService.getItem('skipIcRedirection');
          if (this.skipRedirection == 'yes' || this.skipIcRedirection) {
            this.matDialogRef.close("success");
            this.landingPageService.openConsumerSignIn();
            return;
          }
          this.router.navigateByUrl(this.router.url);
        } else {
          if(result["message"] == "You cannot reuse any of your last 12 passwords. Please choose a new password."){
            this.OL_requestPassword('reset');
            this.toastr.error(result["message"] + " Sent new OTP to your mail");
          }else{
            this.toastr.error(result["message"]);
          }
        }
        // this.message = result.message;
      }, error => {
        console.log(error);
      });
    }
  }

  clearConfirmPassword() {
    this.forgotPwdForm.patchValue({ confirmPassword: "" });
  }

}
